import {__} from "@wordpress/i18n";

/**
 * Array of 12 Chinese zodiac sign objects, indexed by (year % 12).
 * Index 0 corresponds to the Monkey (year % 12 === 0), and so on in cycle order.
 *
 * Each object contains:
 * @property {string} zodiac        - Translated name of the zodiac animal.
 * @property {string} element       - Associated Chinese element (Metal, Water, Wood, Fire, Earth).
 * @property {string} yin_yang      - Polarity of the sign (Yin or Yang).
 * @property {string} lunar_month   - Corresponding lunar month.
 * @property {string} numbers       - Lucky numbers for this sign.
 * @property {string} flower        - Lucky flower(s) for this sign.
 * @property {string} color         - Lucky color(s) for this sign.
 * @property {string} description   - Short translated personality description.
 * @property {string} chinese       - Chinese character of the animal.
 * @property {string} img           - Image filename (without extension) used in /images/.
 */
const zodiacResultContentArray = [
	{
		"zodiac": __("Singe", "superprof-gutenberg-blocks"),
		"element": __("Métal", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yang", "superprof-gutenberg-blocks"),
		"lunar_month": __("7e", "superprof-gutenberg-blocks"),
		"numbers": "3, 7, 9",
		"flower": __("Chrysanthème", "superprof-gutenberg-blocks"),
		"color": __("Blanc", "superprof-gutenberg-blocks"),
		"description": __("Le Singe est ingénieux et plein de ressources. Ce signe est toujours à la recherche de nouvelles connaissances, s'amusant à résoudre des énigmes et des problèmes complexes avec aisance.", "superprof-gutenberg-blocks"),
		"chinese": "猴",
		"img": "singe"
	},
	{
		"zodiac": __("Coq", "superprof-gutenberg-blocks"),
		"element": __("Métal", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yin", "superprof-gutenberg-blocks"),
		"lunar_month": __("8e", "superprof-gutenberg-blocks"),
		"numbers": "5, 7, 8",
		"flower": __("Glaïeul", "superprof-gutenberg-blocks"),
		"color": __("Doré, brun, ocre", "superprof-gutenberg-blocks"),
		"description": __("Le Coq est extrêmement organisé et toujours attentif aux détails. Ce signe est connu pour son honnêteté et son travail acharné, et n'a pas peur de dire sa vérité.", "superprof-gutenberg-blocks"),
		"chinese": "鷄",
		"img": "coq"
	},
	{
		"zodiac": __("Chien", "superprof-gutenberg-blocks"),
		"element": __("Terre", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yang", "superprof-gutenberg-blocks"),
		"lunar_month": __("9e", "superprof-gutenberg-blocks"),
		"numbers": "3, 4, 9",
		"flower": __("Rose", "superprof-gutenberg-blocks"),
		"color": __("Noir", "superprof-gutenberg-blocks"),
		"description": __("Le Chien est le symbole de la loyauté et de la confiance. Toujours fiable, ce signe offre un soutien inconditionnel à ses amis et a un fort sens de la justice.", "superprof-gutenberg-blocks"),
		"chinese": "狗",
		"img": "chien"
	},
	{
		"zodiac": __("Cochon", "superprof-gutenberg-blocks"),
		"element": __("Eau", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yin", "superprof-gutenberg-blocks"),
		"lunar_month": __("10e", "superprof-gutenberg-blocks"),
		"numbers": "2, 5, 6, 8",
		"flower": __("Lys", "superprof-gutenberg-blocks"),
		"color": __("Jaune", "superprof-gutenberg-blocks"),
		"description": __("Le Cochon est authentique et honnête, caractérisé par un grand cœur et une attitude indulgente. Il est fiable et sincère, avec une tendance naturelle vers la gentillesse.", "superprof-gutenberg-blocks"),
		"chinese": "猪",
		"img": "cochon"
	},
	{
		"zodiac": __("Rat", "superprof-gutenberg-blocks"),
		"element": __("Eau", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yang", "superprof-gutenberg-blocks"),
		"lunar_month": __("11e", "superprof-gutenberg-blocks"),
		"numbers": "2, 5, 6, 8",
		"flower": __("Liliacée", "superprof-gutenberg-blocks"),
		"color": __("Jaune", "superprof-gutenberg-blocks"),
		"description": __("Le Rat est connu pour son astuce et sa capacité à s'adapter rapidement à de nouvelles situations. Il vit sa vie avec intelligence et versatilité, trouvant des solutions créatives aux problèmes.", "superprof-gutenberg-blocks"),
		"chinese": "鼠",
		"img": "rat"
	},
	{
		"zodiac": __("Bœuf (ou Buffle)", "superprof-gutenberg-blocks"),
		"element": __("Terre", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yin", "superprof-gutenberg-blocks"),
		"lunar_month": __("12e", "superprof-gutenberg-blocks"),
		"numbers": "0, 9, 13",
		"flower": __("Tulipe", "superprof-gutenberg-blocks"),
		"color": __("Bleu", "superprof-gutenberg-blocks"),
		"description": __("Le Bœuf est le symbole du travail acharné et de la détermination. Avec une approche méthodique et une patience inégalée, il prend ses responsabilités très au sérieux.", "superprof-gutenberg-blocks"),
		"chinese": "牛",
		"img": "buffle"
	},
	{
		"zodiac": __("Tigre", "superprof-gutenberg-blocks"),
		"element": __("Bois", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yang", "superprof-gutenberg-blocks"),
		"lunar_month": __("1er", "superprof-gutenberg-blocks"),
		"numbers": "0, 1, 3, 4, 5",
		"flower": __("Cineraria", "superprof-gutenberg-blocks"),
		"color": __("Gris", "superprof-gutenberg-blocks"),
		"description": __("Le Tigre incarne le courage et la passion. Ce signe est toujours prêt à se lancer dans de nouvelles aventures ou défis, guidé par un élan ardent et un fort instinct.", "superprof-gutenberg-blocks"),
		"chinese": "虎",
		"img": "tigre"
	},
	{
		"zodiac": __("Lapin", "superprof-gutenberg-blocks"),
		"element": __("Bois", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yin", "superprof-gutenberg-blocks"),
		"lunar_month": __("2e", "superprof-gutenberg-blocks"),
		"numbers": "3, 6, 9",
		"flower": __("Plantago", "superprof-gutenberg-blocks"),
		"color": __("Noir", "superprof-gutenberg-blocks"),
		"description": __("Le Lapin est un animal de nature douce et attentionnée, qui préfère la tranquillité et l'harmonie. Il valorise les relations et cherche toujours à éviter les conflits.", "superprof-gutenberg-blocks"),
		"chinese": "兔",
		"img": "lapin"
	},
	{
		"zodiac": __("Dragon", "superprof-gutenberg-blocks"),
		"element": __("Terre", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yang", "superprof-gutenberg-blocks"),
		"lunar_month": __("3e", "superprof-gutenberg-blocks"),
		"numbers": "1, 6, 7",
		"flower": __("Jacinthes", "superprof-gutenberg-blocks"),
		"color": __("Jaune, Vert", "superprof-gutenberg-blocks"),
		"description": __("Le Dragon est charismatique et plein de vitalité, souvent vu comme un leader naturel. Ambitieux et audacieux, le Dragon n'hésite pas à poursuivre ses rêves.", "superprof-gutenberg-blocks"),
		"chinese": "龍",
		"img": "dragon"
	},
	{
		"zodiac": __("Serpent", "superprof-gutenberg-blocks"),
		"element": __("Feu", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yin", "superprof-gutenberg-blocks"),
		"lunar_month": __("4e", "superprof-gutenberg-blocks"),
		"numbers": "2, 8, 9",
		"flower": __("Orchidées", "superprof-gutenberg-blocks"),
		"color": __("Rouge", "superprof-gutenberg-blocks"),
		"description": __("Le Serpent est profond et réfléchi, souvent vu comme un penseur et un philosophe. Ce signe privilégie une stratégie calculée plutôt que l'impulsivité.", "superprof-gutenberg-blocks"),
		"chinese": "蛇",
		"img": "serpent"
	},
	{
		"zodiac": __("Cheval", "superprof-gutenberg-blocks"),
		"element": __("Feu", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yang", "superprof-gutenberg-blocks"),
		"lunar_month": __("5e", "superprof-gutenberg-blocks"),
		"numbers": "1, 4, 5, 7, 9",
		"flower": __("Tournesol", "superprof-gutenberg-blocks"),
		"color": __("Doré", "superprof-gutenberg-blocks"),
		"description": __("Le Cheval aime la liberté et l'indépendance. C'est un signe qui se déplace rapidement, aime l'aventure et se repose rarement trop longtemps au même endroit.", "superprof-gutenberg-blocks"),
		"chinese": "馬",
		"img": "cheval"
	},
	{
		"zodiac": __("Chèvre", "superprof-gutenberg-blocks"),
		"element": __("Terre", "superprof-gutenberg-blocks"),
		"yin_yang": __("Yin", "superprof-gutenberg-blocks"),
		"lunar_month": __("6e", "superprof-gutenberg-blocks"),
		"numbers": "2, 3, 4, 7, 9",
		"flower": __("Œillet", "superprof-gutenberg-blocks"),
		"color": __("Vert, rouge, violet", "superprof-gutenberg-blocks"),
		"description": __("La Chèvre est créative et artistique, souvent immergée dans des activités qui expriment son inclination naturelle vers la beauté et l'art. Elle préfère la paix à la compétition.", "superprof-gutenberg-blocks"),
		"chinese": "羊",
		"img": "chevre"
	}
];

export default zodiacResultContentArray;
